/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_DataInputs */

const en_loading_data = /** @type {(inputs: Loading_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Getting things ready`)
};

const id_loading_data = /** @type {(inputs: Loading_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menyiapkan data untukmu`)
};

/**
* | output |
* | --- |
* | "Getting things ready" |
*
* @param {Loading_DataInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const loading_data = /** @type {((inputs?: Loading_DataInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_DataInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_loading_data(inputs)
	return en_loading_data(inputs)
});